/**
 * Centralized read of build-time public env vars consumed by the portal.
 *
 * `scripts/dev/run.ts` injects VITE_API_URL and VITE_MARKETPLACE_URL from the
 * per-workspace ports.json under `bun run dev:portal`. Build pipelines load
 * VITE_API_URL / VITE_MARKETPLACE_URL from `.env.dev|preview|prod`. The
 * fallbacks below match `ports.example.json` so a bare `vite dev` (no wrapper)
 * still resolves a sensible default; in any provisioned dev/preview/prod build
 * the env var is set and the fallback never fires.
 *
 * Centralizing these here means future port/host changes are a one-file edit.
 */

export const API_URL: string =
	import.meta.env.VITE_API_URL || "http://localhost:7001";

export const MARKETPLACE_URL: string =
	import.meta.env.VITE_MARKETPLACE_URL || "http://localhost:7003";
